import { render, staticRenderFns } from "./personnel_discipline.vue?vue&type=template&id=fb9675b8&scoped=true&"
import script from "./personnel_discipline.vue?vue&type=script&lang=js&"
export * from "./personnel_discipline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9675b8",
  null
  
)

export default component.exports